"use client";
import type { BoostTimerFragment } from "@workspace/casino_core/queries/BoostNotificationQuery";
import Content from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/Content";
import Body from "@/ui/Games/CasinoBoostNotification/Body";
import Footer from "@/ui/Games/CasinoBoostNotification/Footer";

const CasinoBoostNotification: FC<NotificationViewProps> = ({
  notification,
  onClose,
  context,
}) => {
  const boost = notification.data as BoostTimerFragment;
  return (
    <Content
      onClose={onClose}
      className="bg-background"
      testId="casino-boost-notification"
    >
      <Body boost={boost} context={context} />
      <Footer boost={boost} context={context} onClose={onClose} />
    </Content>
  );
};

export default CasinoBoostNotification;
